
import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
//import Slider from "react-slick";
//import axios from 'axios'
//import { auth } from '../../../../../../services';
//import { ROOT_API_URL } from "../../../../../../api-config";
import { updateBilling } from '../../../../../Redux/Actions/EndUser/StoreActions';

class StoreBillingInfo extends React.Component {
    constructor(props) {
        super(props);

        var billingInfo = props.store && props.store.billingInfo ? props.store.billingInfo : null;

        this.state = {
            BillingAddress1: billingInfo && billingInfo.BillingAddress1 ? billingInfo.BillingAddress1 :  "",
            BillingAddress2: billingInfo && billingInfo.BillingAddress2 ? billingInfo.BillingAddress2 :  "",
            BillingCity: billingInfo && billingInfo.BillingCity ? billingInfo.BillingCity :  "",
            BillingZip: billingInfo && billingInfo.BillingZip ? billingInfo.BillingZip :  "",
            BillingStateId: billingInfo && billingInfo.BillingStateId ? billingInfo.BillingStateId : 0,
            BillingState: billingInfo && billingInfo.BillingState ? billingInfo.BillingState : { id: 0, name: "" },
            states: billingInfo && billingInfo.states && billingInfo.states.length ? billingInfo.states : [],
            UseBillingInfo: billingInfo && billingInfo.UseBillingInfo ? billingInfo.UseBillingInfo : false,
            condition: billingInfo && billingInfo.condition ? billingInfo.condition : false
        };
    }

    componentDidMount() {
        this.props.fetchStates();
        this.props.updateBilling(this.state);
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, function () {
            this.props.updateBilling(this.state);
        });
    }

    handleState = (event) => {
        console.log(event.target.value);
        this.setState({
            BillingState: event.target.value,
            BillingStateId: event.target.value.id
        }, function () {
            this.props.updateBilling(this.state);
        });
    }

    handleBillingCheckoutClick = (event) => {
        this.setState({
            condition: !this.state.condition
        });
    }

    billingInfoToggle = () => {
        if (!this.state.UseBillingInfo) {
            if (this.props.store && this.props.store.shippingInfo) {

                const shippingInfo = this.props.store.shippingInfo;

                this.setState({
                    BillingAddress1: shippingInfo.Address1,
                    BillingAddress2: shippingInfo.Address2,
                    BillingCity: shippingInfo.City,
                    BillingZip: shippingInfo.Zip,
                    BillingStateId: shippingInfo.StateId,
                    BillingState: shippingInfo.StateObject
                });
            }
        } else {
            this.setState({
                BillingAddress1: '',
                BillingAddress2: '',
                BillingCity: '',
                BillingZip: '',
                BillingStateId: '',
                BillingState: {
                    id: 0,
                    name: ""
                },
            });
        }

        this.setState({
            UseBillingInfo: !this.state.UseBillingInfo
        }, function () {
            this.props.updateBilling(this.state);
        });
    }

    render() {
        return (
            <div id="storeBillingContainer">
                <div className="form-group">
                    <div className="custom-control custom-checkbox my-1 mr-sm-2">
                        <input
                            type="checkbox"
                            onClick={this.handleBillingCheckoutClick}
                            className="custom-control-input"
                            onChange={this.billingInfoToggle}
                            name="UseBillingInfo"
                            value={this.state.UseBillingInfo}
                            id="UseBillingInfo"
                        />
                        <label htmlFor="UseBillingInfo">
                            <span className={this.state.condition ? " far fa-check-square" : "far fa-square"}></span>
                            <span className="custom-control-text">Use my mailing information for billing information.</span>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6XX card-section-address">
                        <FormGroup>
                            <Label htmlFor="BillingAddress1">Address 1</Label>
                            <Input type="text"
                                id="BillingAddress1"
                                value={this.state.BillingAddress1 || ""}
                                onChange={this.handleChange}
                                name="BillingAddress1"
                                invalid={this.props.touched.BillingAddress1 && this.state.BillingAddress1 === '' ? true : false}
                                onBlur={this.props.handleBlur('BillingAddress1')}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-12 col-md-6XX card-section-address">
                        <FormGroup>
                            <Label htmlFor="BillingAddress2">Address 2</Label>
                            <Input type="text"
                                id="BillingAddress2"
                                value={this.state.BillingAddress2 || ""}
                                onChange={this.handleChange}
                                name="BillingAddress2"
                            />
                        </FormGroup>
                    </div>
                {/* </div>
                <div className="row"> */}
                    <div className="col-sm-12 col-md-4XX card-section-city">
                        <FormGroup>
                            <Label htmlFor="BillingCity">City</Label>
                            <Input type="text"
                                id="BillingCity"
                                value={this.state.BillingCity || ""}
                                onChange={this.handleChange}
                                name="BillingCity"
                                invalid={this.props.touched.BillingCity && this.state.BillingCity === '' ? true : false}
                                onBlur={this.props.handleBlur('BillingCity')}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-6 col-md-4XX card-section-state">
                        <FormGroup>
                            <label htmlFor="billingState">State </label>
                            <DropDownList data={this.props.common.states}
                                name="BillingState"
                                textField="name"
                                dataItemKey="id"
                                onChange={this.handleState}
                                value={this.state.BillingState || { id: 0, name: "" }}
                                className={this.props.touched.BillingState && this.state.BillingState.name === '' ? "error" : ""}
                                onBlur={this.props.handleBlur('BillingState')}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-sm-6 col-md-4XX card-section-zip">
                        <FormGroup>
                            <Label htmlFor="BillingZip">Zip Code</Label>
                            <Input type="text"
                                id="BillingZip"
                                value={this.state.BillingZip || ""}
                                onChange={this.handleChange}
                                name="BillingZip"
                                placeholder="Zip"
                                invalid={this.props.touched.BillingZip && this.state.BillingZip === '' ? true : false}
                                onBlur={this.props.handleBlur('BillingZip')}
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.store,
        common: state.common
    }
}

export default connect(mapStateToProps, { updateBilling, fetchStates })(StoreBillingInfo);
